/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import authActions from '../../../redux/features/auth/actions';
import useAuthorizedEpApps from '../../../hooks/useAuthorizedEpApps';
// import config from '../../config/config';
import { PERFORMANCE_INSIGHTS_APP_NAME } from '../../../constants';
import { usePopupManager } from '../../../providers/PopupManager/PopupManager';
import styles from './RecordToReportAgratasPage.module.css';
import RecordToReportMainDashboard from '../../../components/RecordToReportComp/MainDashboard/MainDashboard';
import MainDashBoardJLR from '../../../components/RecordToReportComp/MainDashBoardJLR/MainDashBoardJLR';
import MainDashBoardAgratas from '../../../components/RecordToReportComp/MainDashBoardAgratas/MainDashBoardAgratas';
// import RecordToReportMainDashboard from '../../components/RecordToReportComp/MainDashboard/MainDashboard';

const RecordToReportAgratasPage = ({
  isAuthenticated,
  authPolicies,
  currentUserId,
}) => {

  const authorizedApps = useAuthorizedEpApps(isAuthenticated, authPolicies);
  const { showLoading } = usePopupManager();
  const history = useHistory();

  useEffect(() => {
    if (
      authorizedApps.length &&
      !authorizedApps.includes(PERFORMANCE_INSIGHTS_APP_NAME)
    ) {
      showLoading();
      window.location.replace(config.HOME_UI_BASE_URL);
    }
  }, [authorizedApps, currentUserId]);

  // ############# Start new code for user auth ##################
  const token = useSelector((state) => state.auth.djangoAccessToken);
  const roles = useSelector((state) => state.auth.djangoRoles);
  const userInfo = useSelector((state) => state.auth.djangoUserInfo);

  const [hasMainPageAccess, setHasMainPageAccess] = useState(true);
  const [accessiblePages, setAccessiblePages] = useState([]);

  useEffect(() => {
    if ( roles !== null ){
      const PagesData = roles.pages;
      setAccessiblePages(roles.pages);
      if (roles.pages.includes("R2R Agratas MainPage")) {
        setHasMainPageAccess(true);
      } else{
        setHasMainPageAccess(false);
      }
    }
  }, [roles]);

  const pageDetails = {
    "R2R Agratas Bank Reconcilation": {
      title: "Agratas Bank Reconcilation",
      path: "/Record-To-Report/Agratas/Bank-Reconcilation"
    },
    "R2R Agratas TimeLiness": {
      title: "Agratas TimeLiness",
      path: "/Record-To-Report/Agratas/TimeLiness"
    }
  };

  const handleTilesClick = (path) =>{
    history.push(path);
  }
  // ############# End new code for user auth ##################

  return (
    <div className={styles.container}>
      {!hasMainPageAccess ? (
        <div className="container mt-4">
        <h3 className="mb-4 text-center" style={{ color: "#0067ac" }}>
          You don't have access to the full R2R Agratas Dashboard.
        </h3>
        <div className="row">
          {accessiblePages.map((page) => {
            const details = pageDetails[page];
            if (!details) return null;
            return (
              <div key={page} className="col-md-4 mb-4">
                <div
                  className="legal-tile-card"
                  onClick={() => handleTilesClick(details.path)}
                >
                  <div className="legal-tile-body">
                    <h5 className="legal-tile-title">{details.title}</h5>
                    <p className="legal-tile-text">Click to view {details.title}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    ) : (
      <MainDashBoardAgratas />
    )}
    </div>
  )
}

RecordToReportAgratasPage.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  authPolicies: PropTypes.object.isRequired,
  currentUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};
  
export default connect(({ auth, userProfile }) => ({
  isAuthenticated: auth.isAuthenticated,
  authPolicies: auth.authPolicies,
  currentUserId: userProfile.userId,
  setAuthToken: authActions.setAuthToken,
}))(RecordToReportAgratasPage);
